/** Logomark do app — disco + pino de rota, mesmo motivo do ícone do PWA. */
export function AppMark({ size = 40 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="19" fill="var(--color-accent)" />
      <circle cx="20" cy="16.5" r="6.5" fill="var(--color-bg)" />
    </svg>
  );
}
